var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2048_7787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10C18.75 15.1775 14.5527 19.375 9.375 19.375C4.1973 19.375 0 15.1775 0 10C0 4.8223 4.1973 0.625 9.375 0.625C14.5527 0.625 18.75 4.8223 18.75 10Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.0031C18.75 10.0031 18.75 10.0031 12.4042 10.0031C12.5109 9.95635 8.75 10.449 8.75 10.449C8.75 10.449 9.57753 13.547 12.6175 14.9726C13.411 15.3446 14.4714 16.2481 14.9984 17.5C17.2783 15.7783 18.75 13.061 18.75 10.0031Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37508 2.5C5.23953 2.5 1.875 5.86453 1.875 10.0001C1.875 14.1355 5.23953 17.5 9.37508 17.5C13.5106 17.5 16.875 14.1356 16.875 10.0001C16.875 5.86453 13.5106 2.5 9.37508 2.5ZM9.37508 15.3758C6.41093 15.3758 3.9994 12.9642 3.9994 10.0001C3.9994 7.03593 6.41093 4.6244 9.37508 4.6244C12.3392 4.6244 14.7508 7.03593 14.7508 10.0001C14.7508 12.9642 12.3392 15.3758 9.37508 15.3758Z",
    fill: "#FD5F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 10H14.6736C14.6736 12.1043 13.8584 13.7053 12.1875 14.6875C12.4295 14.8445 12.5367 14.8667 12.8125 15C13.1904 15.1824 13.6263 15.484 14.0411 15.8851C15.8631 14.4328 16.875 12.536 16.875 10Z",
    fill: "#FF737D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10C11.25 11.0355 10.4106 11.875 9.375 11.875C8.33953 11.875 7.5 11.0355 7.5 10C7.5 8.96438 8.33953 8.125 9.375 8.125C10.4106 8.125 11.25 8.96438 11.25 10Z",
    fill: "#FD5F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10C10.1798 10.133 8.75 10.3209 8.75 10.3209C8.75 10.3209 8.93153 11.0031 9.43695 11.875C10.4162 11.7763 11.1887 10.9837 11.25 10Z",
    fill: "#FF737D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.478 8.125H16.618C16.3929 8.125 16.177 8.2135 16.0178 8.37148L14.375 10L16.0178 11.6285C16.177 11.7863 16.3929 11.875 16.618 11.875H19.478C19.9358 11.875 20.171 11.3317 19.8556 11.0026L19.2649 10.3866C19.0571 10.1699 19.0571 9.82989 19.2649 9.61323L19.8556 8.99719C20.171 8.66828 19.9358 8.125 19.478 8.125Z",
    fill: "#B2E59C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.478 8.125H16.618C16.3929 8.125 16.177 8.2135 16.0178 8.37148L14.375 10H19.109C19.109 9.86086 19.1611 9.72156 19.2649 9.61323L19.8556 8.99719C20.171 8.66828 19.9358 8.125 19.478 8.125Z",
    fill: "#7AC1DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6891 10.625H9.56088C9.11291 10.625 8.75 10.3452 8.75 10C8.75 9.65484 9.11291 9.375 9.56088 9.375H16.6891C17.1369 9.375 17.5 9.65484 17.5 10C17.5 10.3452 17.1369 10.625 16.6891 10.625Z",
    fill: "#B2785B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2048_7787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.a0b4dd27ec3d6704207355bd7da85e10.svg";
export { ForwardRef as ReactComponent };